module.exports = __webpack_public_path__ + "static/media/SF-6-A (1).f654eaf0.mp3";